import { render } from "./PrivilegeDetailsModal.vue?vue&type=template&id=48fd319a"
import script from "./PrivilegeDetailsModal.vue?vue&type=script&lang=js"
export * from "./PrivilegeDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__